import * as React from 'react';
import {MenuItem} from "@mui/material";
import { SelectInput } from '@coverright/ui/inputs';

type Props = {
  value: string;
  onChange: (value: string) => void;
  error?: string,
  label?: string,
  loading?: boolean;
  disabled?: boolean;
  companies: string[];
};

export const CarrierSelector = ({companies, value, error, disabled, onChange, loading, label = 'Carrier'}: Props) => {
  const valueInList = companies.some(c => c.slice(0, c.indexOf('(') - 1) === value);
  return <SelectInput label={label}
                      value={value}
                      loading={loading}
                      onChange={event => {
                        onChange(event.target.value as string);
                      }}
                      disabled={loading || disabled}
                      error={Boolean(error)}
                      helperText={error ? error : undefined}
  >
    {companies.map(c => <MenuItem key={c} value={c.slice(0, c.indexOf('(') - 1)}>{c}</MenuItem>)}
    {!valueInList && (
      <MenuItem value={value}>{value}</MenuItem>
    )}
  </SelectInput>
}
